<template>
  <div style="background-color: #f9f9f9;padding-top: 64px;">
    <!-- 岗位 -->
    <div class="detaileds">
      <div class="detailed-left">
        <div class="detailed-name">
          <div>{{jobInfo.name}}</div>
<!--          <div v-if="jobInfo.salary!==undefined&&jobInfo.salaryEnd!==undefined">{{jobInfo.salary}}-{{jobInfo.salaryEnd}}/月</div>
          <div v-if="jobInfo.salary==undefined&&jobInfo.salaryEnd!==undefined">{{jobInfo.salaryEnd}}元以下</div>
          <div v-if="jobInfo.salaryEnd==undefined&&jobInfo.salary!==undefined">{{jobInfo.salary}}元以上</div>
          <div v-if="jobInfo.isSalary==2">面议</div>-->
          <div v-if="jobInfo.salaryName!==undefined&&jobInfo.salaryName!==null">{{jobInfo.salaryName}}</div>
        </div>
        <div class="detailed-title" style="line-height: 20px;font-size: 14px" >
          <div v-for="(item,index) in jobInfo.typeList" :key="index">
            <img v-if="index==0" src="../assets/jobDetail_tag.png" style="width: 14px;margin-top: 3px;margin-right:1px;float: left"/>
            {{item.title}}
          </div>
          <div >
            <img v-if="jobInfo.address" src="../assets/jobDetail_address.png" style="width: 14px;margin-top: 3px;margin-right:1px;float: left"/>
            {{jobInfo.address}}
          </div>
          <div><img v-if="jobInfo.work" src="../assets/jobDetail_work.png" style="width: 14px;margin-top: 3px;margin-right:1px;float: left"/> {{jobInfo.work}}</div>
          <div><img v-if="jobInfo.edu" src="../assets/jobDetail_edu.png" style="width: 14px;margin-top: 3px;margin-right:1px;float: left"/>{{jobInfo.edu}}</div>
        </div>
        <div class="detaileds-tabel">
          <div v-for="(item,index) in jobInfo.tagList" :key="index">{{item.title}}</div>
        </div>
      </div>
      <div class="jobDetails-detaileds-right" v-if="jobInfo.isEdit==false">
        <div class="jobDetails-detaileds-box" @click="collect()">
          <img v-if="gather==false" style="width: 20px;height: 20px;margin-top: 13px;margin-left: 26px;" src="../assets/jobcollect.png" />
          <img v-if="gather==true" style="width: 20px;height: 20px;margin-top: 13px;margin-left: 26px;" src="../assets/iscollect.png" />
          <div>收藏</div>
        </div>
        <div class="jobDetails-detaileds-boxs" style="background: #577DF4" v-if="Logintoken==null" @click="enroll()">
          <img src="../assets/enroll.png" />
          <div>一键投递</div>
        </div>
<!--        <div class="jobDetails-detaileds-boxs" style="background: #577DF4" v-if="Logintoken!=null&&jobInfo.isSignUp==false&&userInfo.identity==1" :style="{'background-color' : jobInfo.isSignUp == false ? '#577df4' : '#f6f6f6'}" @click="enroll()">-->
<!--          <img src="../assets/enroll.png" />-->
<!--          <div v-if="jobInfo.isSignUp==false">一键投递</div>-->
<!--        </div>-->
        <div class="jobDetails-detaileds-boxs" style="background: #577DF4" v-if="Logintoken!=null&&jobInfo.isSignUp==false&&userInfo.identity!=2" :style="{'background-color' : jobInfo.isSignUp == false ? '#577df4' : '#f6f6f6'}" @click="enroll()">
          <img src="../assets/enroll.png" />
          <div v-if="jobInfo.isSignUp==false">一键投递</div>
        </div>
        <div class="jobDetails-detaileds-boxs" style="background: #f6f6f6;" v-if="Logintoken!=null&&jobInfo.isSignUp==false&&userInfo.identity==2">
          <img src="../assets/isEnroll.png" />
          <div v-if="jobInfo.isSignUp==false" style="color: rgb(143 138 138);">一键投递</div>
        </div>
        <div class="jobDetails-detaileds-boxs" style="background: #577DF4" v-if="Logintoken!=null&&jobInfo.isSignUp==true" :style="{'background-color' : jobInfo.isSignUp == false ? '#577df4' : '#f6f6f6'}">
          <img src="../assets/isEnroll.png" />
          <div style="color: rgb(143 138 138);">已投递</div>
        </div>
        <div class="linkmanBox" v-if="jobInfo.linkMan!==''&&jobInfo.linkPhone!==undefined&&jobInfo.linkPhone!==''&&jobInfo.linkPhone!==undefined">
          <div>
            <img src="../assets/linkMan-phone.png" alt="">
          </div>
          <div>{{jobInfo.linkMan}}:</div>
          <div>{{jobInfo.linkPhone}}</div>
          <div v-if="lookLinkPhoneBtn==true&&Logintoken==null" style="color: #169BD5;margin-left: 10px;cursor: pointer" @click="lookLinkPhone()">查看</div>
          <div v-if="lookLinkPhoneBtn==true&&Logintoken!=null&&userInfo.identity==1" style="color: #169BD5;margin-left: 10px;cursor: pointer" @click="lookLinkPhone()">查看</div>
          <div v-if="lookLinkPhoneBtn==false"></div>
        </div>
      </div>
      <div class="jobDetails-detaileds-right" v-else style="margin-top:64px;">
        <div class="jobDetails-detaileds-box" style="background-color: #fff;border: 1px solid #597BF6;" @click="editJob(id)">
          <div style="color: #597BF6;width: 100%;text-align: center;">编辑</div>
        </div>
        <div class="jobDetails-detaileds-boxs" style="background-color: #597BF6;width: 112px;">
<!--          <div style="color: #fff;width: 100%;text-align: center;" v-if="operations==3" @click="operateJob()">上架</div>-->
<!--          <div style="color: #fff;width: 100%;text-align: center;" v-if="operations==1" @click="operateJob()">下架</div>-->
          <div style="color: #fff;width: 100%;text-align: center;" v-if="jobInfo.status==3" @click="operateJob()">上架</div>
          <div style="color: #fff;width: 100%;text-align: center;" v-if="jobInfo.status==1" @click="operateJob()">下架</div>
        </div>
      </div>
    </div>
    <!-- 岗位 -->

    <!-- 岗位详情 -->
    <div class="conts">
      <div class="conts-boxs">
        <!-- 职位详情 -->
        <div class="conts-top">
          <div class="conts-top-h1" >职位详情</div>
          <div class="conts-top-h2" v-if="content1">职位描述：</div>
          <div class="conts-top-txt" v-if="content1" v-html="content1"></div>
          <div class="conts-top-h2" v-if="content2">岗位要求：</div>
          <div class="conts-top-txt" v-if="content2" v-html="content2"></div>
          <div class="conts-top-h2" v-if="content3">福利待遇：</div>
          <div class="conts-top-txt" v-if="content3" v-html="content3" style="margin-bottom: 0;padding-bottom: 24px;"></div>
        </div>
        <!-- 职位详情 -->
        <!-- 公司信息 -->
        <div class="companys" v-if="jobInfo.length!==0" @click="enterpriseDetails(jobInfo.companyInfo.id)">
          <div class="company-title">公司信息</div>
          <div class="company">
            <img v-if="jobInfo.companyInfo.logo!==''" :src="jobInfo.companyInfo.logo" />
            <img v-if="jobInfo.companyInfo.logo===''" src="../assets/ping.png" />
            <div class="company-details">
              <div class="company-name">{{jobInfo.companyInfo.name}}</div>
              <div class="company-tabel">
                <div>{{jobInfo.companyInfo.nature}}</div>
                <div>{{jobInfo.companyInfo.trade}}</div>
                <div>{{jobInfo.companyInfo.scale}}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 公司信息 -->
        <!-- <img src="../assets/banber.png" style="width: 862px;height: 305px;margin-top: 27px;" /> -->
      </div>
      <div class="enterpriseDetails-login">
        <img class="jobDetails-enterpriseDetails-advertisement" src="../assets/advertisement.png" alt="" />
      </div>
    </div>
    <!-- 岗位详情 -->
  </div>
</template>

<script>

import request from '../util/request.js'

export default{
  data () {
    return {
      jobInfo: [],
      id: '',
      operation: 0,
      gather: false,
      url: '',
      randKey: '',
      num: 0,
      userInfo: {},
      isLogin: false,
      // isexamine: '',
      // operations: 3,
      content1: '',
      content2: '',
      content3: '',
      Logintoken: '',
      lookLinkPhoneBtn: true
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
      this.Logintoken = localStorage.getItem('token')
    })
  },
  mounted () {
    var that = this
    that.id = that.$route.query.id
    // if (that.$route.query.isexamine !== undefined) {
    //   that.isexamine = that.$route.query.isexamine
    //   that.operations = that.$route.query.operation
    // } else {
    //   that.isexamine = false
    // }
  },
  methods: {
    getData () {
      var that = this
      // that.isexamine = that.isexamine
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/index/jobDetail`,
        data: JSON.stringify({
          id: this.id
        })
      }).then(
        (res) => {
          that.jobInfo = {}
          that.jobInfo = res.data.data.jobInfo
          var content1 = res.data.data.jobInfo.list2
          var content2 = res.data.data.jobInfo.list1
          var content3 = res.data.data.jobInfo.list3
          that.content1 = content1.replace(/\n/g, '<br/>')
          that.content2 = content2.replace(/\n/g, '<br/>')
          that.content3 = content3.replace(/\n/g, '<br/>')
          if (that.jobInfo.isCollection === false) {
            that.gather = false
          } else if (that.jobInfo.isCollection === undefined) {
            that.gather = false
          } else {
            that.gather = true
          }
          const phone = that.jobInfo.linkPhone
          that.jobInfo.linkPhone = phone.substr(0, 3) + '****' + phone.substr(7)
        },
        (err) => {
          that.$message.error(err)
        }
      )
      var token = localStorage.getItem('token')
      if (token !== null) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user`,
          data: JSON.stringify({})
        }).then(
          (res) => {
            if (res.data.code === 200) {
              that.userInfo = res.data.data.userInfo
            }
          },
          (err) => {
            console.log(err)
            // if (res.data.code !== 501) {
            //   that.$message.error(err)
            // }
          }
        )
      }
    },
    enterpriseDetails (id) {
      this.$router.push({
        path: '/enterpriseDetails',
        query: {
          id: id
        }
      })
    },
    collect () {
      var that = this
      var token = localStorage.getItem('token')
      if (token === null) {
        that.$message.error('请先登录!')
        this.$bus.emit('iscode', 'true')
        return false
      }
      // if (that.userInfo.identity === 2) {
      //   that.$message.error('企业无法收藏岗位!')
      //   return false
      // }
      if (that.jobInfo.isCollection === false) {
        that.operation = 1
      } else {
        that.operation = 2
      }
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/job/addCollection`,
        data: JSON.stringify({
          id: that.id,
          operation: that.operation
        })
      }).then(
        (res) => {
          if (that.operation === 1) {
            that.$message.success('收藏成功！')
          } else {
            that.$message.success('取消收藏')
          }
          that.getData()
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    enroll () {
      var that = this
      var token = localStorage.getItem('token')
      if (token === null) {
        that.$message.error('请先登录!')
        this.$bus.emit('iscode', 'true')
        return false
      }
      if (that.userInfo.identity === 2) {
        that.$message.error('企业无法投递!')
        return false
      }
      if (that.userInfo.isResume === false) {
        that.$confirm('请填写简历后投递, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({path: '/editResume'})
        }).catch(() => {})
        return false
      }
      if (that.jobInfo.isCollection === false) {
        that.operation = 1
      } else {
        that.operation = 2
      }
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/job/sigUp`,
        data: JSON.stringify({
          id: that.id,
          type: '2'
        })
      }).then(
        (res) => {
          if (res.data.data.isJobResume === false) { // 如果没有简历
            that.$confirm('请完善简历后投递', {
              confirmButtonText: '去填写',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({path: '/editResume'})
            }).catch(() => {})
          } else {
            that.$message.success('投递成功！')
            that.getData()
          }
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    editJob (e) {
      this.$router.push({
        path: '/releaseJob',
        query: {
          id: e
        }
      })
    },
    // 上下架
    operateJob () {
      var that = this
      var operation = that.jobInfo.status
      // console.log(status, 'status')
      // var operation = that.operations
      if (operation === 3) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user/changeJob`,
          data: JSON.stringify({
            id: that.id,
            operation: 1
          })
        }).then(
          (res) => {
            that.$message.success('上架成功')
            that.jobInfo.status = 1
            that.getData()
          },
          (err) => {
            that.$message.error(err)
          }
        )
      } else {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user/changeJob`,
          data: JSON.stringify({
            id: that.id,
            operation: 2
          })
        }).then(
          (res) => {
            that.$message.success('下架成功')
            that.jobInfo.status = 3
            that.getData()
          },
          (err) => {
            that.$message.error(err)
          }
        )
      }
    },
    // 查看联系电话
    lookLinkPhone () {
      var that = this
      var token = localStorage.getItem('token')
      if (token === null) {
        that.$message.error('请先登录!')
        this.$bus.emit('iscode', 'true')
        return false
      }
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `job/company/getPhone`,
        data: JSON.stringify({
          id: this.id,
          orgId: 'e387fd0374a849c39cca698fd4aafcb2'
        })
      }).then(
        (res) => {
          var checkStatus = res.data.data.checkStatus
          if (checkStatus === '1') { // 1是提示完善简历
            that.$confirm('请先完善简历后查看电话', '提示', {
              confirmButtonText: '去完善',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => { // 点击去完善后跳转页面
              that.$router.push({path: '/editResume'})
            }).catch(() => {})
            return false
          } else if (checkStatus === '2') { // 2是提示投递简历
            that.$message.error('投递简历后查看联系方式')
          } else { // 其他状态是直接查看简历
            that.jobInfo.linkPhone = res.data.data.linkPhone // 赋值
            that.lookLinkPhoneBtn = false
          }
        },
        (err) => {
          that.$message.error(err)
        }
      )
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
/* 岗位 */
.detaileds {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fff;
  margin-top: 21px;
}

.detailed-left {
  float: left;
  width: 60%;
}

.detailed-name {
  overflow: hidden;
  font-weight: 550;
  margin-bottom: 20px;
  margin-left: 38px;
  margin-top: 34px;
}

.detailed-name div:first-child {
  float: left;
  font-size: 28px;
}

.detailed-name div:last-child {
  float: left;
  margin-left: 42px;
  font-size: 28px;
  color: #FF8C41;
}

.detailed-title {
  overflow: hidden;
  margin-bottom: 20px;
  margin-left: 38px;
}

.detailed-title div {
  float: left;
  color: #5F5D60;
  margin-right: 24px;
}
.detailed-title div:last-child{
  margin-right: 0;
}
.detaileds-tabel {
  overflow: hidden;
  margin-left: 38px;
  margin-bottom: 31px;
}

.detaileds-tabel div {
  float: left;
  margin-right: 10px;
  color: #027FFE;
  border: 1px solid #0091FF;
  border-radius: 5px;
  padding: 5px 7px 4px 6px;
  font-size: 12px;
}

.jobDetails-detaileds-right {
  float: right;
  overflow: hidden;
  margin-top: 76px;
  padding-bottom: 27px;
}

.jobDetails-detaileds-box {
  float: left;
  margin-right: 20px;
  width: 110px;
  overflow: hidden;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
  border: 1px solid #577DF4;
  cursor:pointer;
}

.jobDetails-detaileds-box img {
  width: 15px;
  height: 15px;
  float: left;
  margin-top: 14px;
  margin-left: 32px;
  margin-right: 5px;
}

.jobDetails-detaileds-box div {
  float: left;
  color: #577DF4;
}

.jobDetails-detaileds-boxs {
  float: left;
  background-color: #577DF4;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
  width: 222px;
  border-radius: 5px;
  margin-right: 36px;
  cursor:pointer;
}

.jobDetails-detaileds-boxs img {
  width: 15px;
  height: 15px;
  float: left;
  margin-top: 14px;
  margin-left: 75px;
  margin-right: 5px;
}

.jobDetails-detaileds-boxs div {
  color: #fff;
  float: left;
}

/* 岗位详情 */
.conts{
  width: 1200px;
  margin: 0 auto;
  margin-top: 16px;
  overflow: hidden;
}
.conts-boxs{
  float: left;
  width: 870px;
  margin-right: 30px;
  margin-bottom: 20px;
}
.conts-top{
  margin-bottom: 16px;
  background-color: #fff;
  text-align: left;
}
.conts-top-h1{
  margin-left: 35px;
  padding-top: 22px;
  font-size: 18px;
  font-weight: 550;
  margin-bottom: 24px;
}
.conts-top-h2{
  margin-left: 35px;
  font-size: 16px;
  font-weight: 550;
  margin-bottom: 24px;
}
.conts-top-txt{
  color: #868686;
  margin-left: 35px;
  margin-bottom: 24px;
  line-height: 22px;
  font-size: 14px;
  margin-right: 20px;
}
/* 公司信息 */
.companys{
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  cursor:pointer;
}
.company-title{
  font-weight: 550;
  text-align: left;
  margin-left: 36px;
  padding-top: 17px;
  font-size: 18px;
}
.company {
  overflow: hidden;
  margin-left: 35px;
  margin-top: 23px;
  padding-bottom: 18px;
}
.company img {
  float: left;
  width: 77px;
  height: 77px;
}
.company-details {
  float: left;
  margin-left: 17px;
  width: 60%;
  text-align: left;
  margin-top: 9px;
}
.company-name {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 550;
}
.company-tabel {
  overflow: hidden;
  color: #7A7A7A;
}
.company-tabel div {
  float: left;
  margin-right: 24px;
}
.enterpriseDetails-login{
  float: left;
}
.jobDetails-enterpriseDetails-advertisement{
  width: 300px;
  border-radius: 10px;
  margin-bottom: 20px;
}
.linkmanBox{
  line-height: 22px;
  height: 22px;
  font-size: 16px;
  color: #868686;
  margin-top: 63px;
  margin-left: 133px;
}
.linkmanBox div{
  float: left;
}
.linkmanBox div img{
  width: 14px;
  height: 14px;
  margin-top: 4px;
}
.linkmanBox div:first-child{
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/jobDetails.vue